import { render, staticRenderFns } from "./ArtworkSave.vue?vue&type=template&id=6057218c"
import script from "./ArtworkSave.vue?vue&type=script&lang=js"
export * from "./ArtworkSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports